import Network, { FTPURL } from "../../utils/Network";
import { roundFloat } from "../../utils/round-float";

class BuildingService {
  private axios: Network;

  constructor() {
    this.axios = new Network();
  }

  async getAllBuildings() {
    const response = await this.axios.CallApi({
      url: "/building",
      method: "get",
    });

    if (response?.ok && response?.data && Array.isArray(response.data)) {
      const allData = response.data.map((item: any) => ({
        ...item,
        id: item?.id,
        buildingId: item?.buildingId,
        title: item?.name,
        image: FTPURL + "/" + item?.photo,
        health: roundFloat(item?.currentHealth),
        capacity: roundFloat(item?.currentMaxCapacity),
        filled: roundFloat(item?.currentCapacity),
        count: item?.currentLevel,
        video: FTPURL + "/" + item?.video,
        status: item?.state,
        upgradeTime: item?.nextEventDate,
        currentDailyProduction: item.currentDailyProduction,
        disabled: item?.state === -1,
      }));
      return { success: true, data: allData };
    }
    return { success: false, message: response?.message || "Failed to fetch buildings" };
  }

  async getBuildingDetail(id: number | string) {
    if (!id && !parseInt(id?.toString())) {
      return { success: false, message: "Invalid building ID" };
    }
    
    const response = await this.axios.CallApi({
      url: "/building/" + id,
      method: "get",
    });
    
    return response;
  }

  async upgradeBuilding(id: number | string) {
    const response = await this.axios.CallApi({
      url: `/building/${id}/repair-upgrade`,
      method: "get",
    });
    return response;
  }

  async repairBuilding(id: number | string, options?: {
    clegUse: number | string;
    ironUse: number | string;
    stoneUse: number | string;
  }) {
    const queryParams = options
      ? `?clegUse=${options?.clegUse}&stoneUse=${options.stoneUse}&ironUse=${options.ironUse}`
      : "";
      
    const response = await this.axios.CallApi({
      url: `/building/${id}/repair${queryParams}`,
      method: "get",
    });
    
    return response;
  }

  async collectFromBuilding(id: number | string) {
    const response = await this.axios.CallApi({
      url: `/building/${id}/collect`,
      method: "get",
    });
    
    return response;
  }

  async buildBuilding(id: number | string) {
    const response = await this.axios.CallApi({
      url: `/building/${id}/build`,
      method: "get",
    });
    
    return response;
  }
}

export default new BuildingService(); 

